export default {"src":"/_next/static/media/200-series.b485c36a.svg","height":1000,"width":1000};